import { SceneSprite } from "GameObjects/StoryGame/SceneSprite";
import { Expo, TimelineLite, TimelineMax, TweenLite } from "gsap";
import * as HLF from "html-living-framework";
import { Application } from "Singletons/Application";
import { AbstractStoryState } from "States/AbstractStoryState";
import { list } from "Utils/Reflection";

import { ch6_p12 } from "../../../layouts/ch6_p12/ch6_p12";

export class Chapter6Page12 extends AbstractStoryState implements ReturnType<typeof ch6_p12> {

    readonly bg = this.addChild(new SceneSprite());
    readonly hands = this.addChild(new SceneSprite());
    readonly rain = this.addChild(new SceneSprite());
    readonly sparkleOne = [this.addChild(new SceneSprite()), this.addChild(new SceneSprite()), this.addChild(new SceneSprite()), this.addChild(new SceneSprite())];
    readonly sparkleTwo = [this.addChild(new SceneSprite()), this.addChild(new SceneSprite()), this.addChild(new SceneSprite()), this.addChild(new SceneSprite())];
    readonly sparkleThree = [this.addChild(new SceneSprite()), this.addChild(new SceneSprite()), this.addChild(new SceneSprite()), this.addChild(new SceneSprite())];
    readonly sparkles = this.addChild(new SceneSprite());
    readonly glow = this.addChild(new SceneSprite());

    readonly frameLeft = this.addChild(SceneSprite.withPrefix("ch6_p12/"));
    readonly frameRight = this.addChild(SceneSprite.withPrefix("ch6_p12/"));

    dontScaleUp = true;

    protected sparkleTimelines: TimelineMax[] = [];

    public init(pSize: PIXI.Point, pData: any) {
        // exported layouts from Animate CC
        ch6_p12.call(this);

        this.makeSparkle(this.sparkleOne, {fps: 6, delay: 0, altPos: {x: -262, y: -64}});
        this.makeSparkle(this.sparkleTwo, {fps: 6, delay: 1/8, altPos: {x: -243, y: 58}});
        this.makeSparkle(this.sparkleThree, {fps: 6, delay: 2/8, altPos: {x: -194, y: -160}});

        // super.init calls onResize
        super.init(pSize, pData);
    }

    public update(pDeltaTime: number) {
        super.update(pDeltaTime);
    }

    public animateIn(pOnComplete: () => void) {
        super.animateIn(pOnComplete);

        const glowTimeline = new TimelineMax()
            glowTimeline.fromTo(this.glow, 3, {pixi: {alpha: 0}}, {pixi: {alpha: 1}});
            glowTimeline.yoyo(true);
            glowTimeline.repeat(-1);
    }

    public animateOut(pOnComplete: () => void) {
        super.animateOut(pOnComplete);
    }

    public onAnimateInComplete() {
        super.onAnimateInComplete();
        TweenLite.delayedCall(1.5, ()=>{
            this.gotoNextState({transition: "left"});
        });
    }

    public destroy() {
        super.destroy();
        this.sparkleTimelines.forEach(t=>t.kill());
    }

    protected makeSparkle(
        pSprites: SceneSprite[],
        pOptions: {fps: number, delay: number, altPos: {x: number, y: number}},
    ) {
        pSprites.forEach(s=>s.visible = false);

        const sparkleTimeline = new TimelineMax();
        sparkleTimeline.delay(pOptions.delay);
        sparkleTimeline.repeat(-1);

        for (let i = 0; i < pSprites.length; i++) {
            sparkleTimeline.call(() => {
                pSprites[((i - 1) + pSprites.length) % pSprites.length].visible = false;
                pSprites[i].visible = true;
            }, undefined, undefined, i / pOptions.fps);
        }

        sparkleTimeline.call(() => {
            pSprites.forEach(s=>s.visible = false);
            pSprites.forEach(s=>s.x += pOptions.altPos.x);
            pSprites.forEach(s=>s.y += pOptions.altPos.y);
        }, undefined, undefined, pSprites.length * (1 / pOptions.fps));

        for (let i = 0; i < pSprites.length; i++) {
            sparkleTimeline.call(() => {
                pSprites[((i - 1) + pSprites.length) % pSprites.length].visible = false;
                pSprites[i].visible = true;
            }, undefined, undefined, `+=${1 / pOptions.fps}`);
        }

        sparkleTimeline.call(() => {
            pSprites.forEach(s=>s.visible = false);
            pSprites.forEach(s=>s.x -= pOptions.altPos.x);
            pSprites.forEach(s=>s.y -= pOptions.altPos.y);
        }, undefined, undefined, `+=${(1 / pOptions.fps)}`);

        this.sparkleTimelines.push(sparkleTimeline);
    }

}